$ = require('jquery');


var scrollVal = $(window).scrollTop();
var originalScroll = 0;

$(window).on('scroll', function(){
    scrollVal = $(window).scrollTop();
});



$(function () {
    $('#burger').on('click', function () {
        if( $('body').hasClass('menu_active') ){
            $('body').removeClass('noscroll').css({'top':''}).removeClass('menu_active');
            $(window).scrollTop(originalScroll);
        }else{
            originalScroll = scrollVal;
            $('body').addClass('noscroll').css('top',-scrollVal).addClass('menu_active');
        }
    })
});
